import React from "react";
import * as PropTypes from "prop-types";
import {Checkbox, TableCell, TableHead, TableRow, TableSortLabel, Tooltip} from "@material-ui/core";

function EnhancedTableHead(props) {
    const createSortHandler = property => event => {
        props.onRequestSort(event, property);
    };

    const {order, orderBy, numSelected, rowCount, onSelectAllClick, rows} = props;

    return (
        <TableHead>
            <TableRow>
                {
                    (props.checkbox || props.firstColumn.component) &&
                    <TableCell padding="checkbox" style={{textAlign: 'left'}}>
                        {props.checkbox &&
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                        }
                        {
                            props.firstColumn.component && props.firstColumn.title
                        }
                    </TableCell>
                }
                {
                    rows.filter(r => !r.hide).map(
                        row => (<TableCell
                            key={row.id}
                            align="left"
                            padding={row.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === row.id ? order : false}>
                            <Tooltip
                                title="Ordenar"
                                placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                enterDelay={300}>
                                <TableSortLabel
                                    active={orderBy === row.id}
                                    direction={order}
                                    onClick={createSortHandler(row.id)}>
                                    {row.label}
                                </TableSortLabel>
                            </Tooltip>
                        </TableCell>)
                    )
                }
            </TableRow>
        </TableHead>
    );

}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    firstColumn: PropTypes.object,
    checkbox: PropTypes.bool,
    rows: PropTypes.array,
};

EnhancedTableHead.defaultProps = {
    firstColumn: {},
    order: 'id',
    orderBy: 'asc',
    rows: [],
};

export default EnhancedTableHead;
